// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1rbYf","title":"InfoRow_title__1KoEZ"};